export const typing_test_view = (
  reference_text_paragraphs,
  typing_answer_paragraphs,
  typing_test_diff,
  reference_typing_text,
  typing_answer
) => {
  let error_count = 0;
  let element = null;
  let paragraph = null;
  let fragment = document.createDocumentFragment();

  let commonTexts = "";

  let removedWord = "";
  let addedWord = "";
  let errors = [];

  // reference_text_paragraphs.forEach((reference_text_paragraph, index) => {
  //   paragraph = document.createElement("p");
  //   paragraph.style.lineHeight = "normal";

  //   if (typing_answer_paragraphs[index] !== undefined) {
  //     paragraph_diff = diffWordsWithSpace(
  //       reference_text_paragraph,
  //       typing_answer_paragraphs[index],
  //       { ignoreWhitespace: false }
  //     );

  //     if (index !== typing_answer_paragraphs.length - 1) {
  //       paragraph_diff.forEach((part, idx) => {
  //         if (part.removed) {
  //           // console.log(part.value);
  //           // diff_color = part.added ? "#fff" : "#627081";
  //           // bg_color = part.added ? "#E03D3C" : "#ffff80";
  //           diff_color =
  //             paragraph_diff[idx + 1] && paragraph_diff[idx + 1].added
  //               ? "#3EB160" // green
  //               : "#FA9A47"; // orange
  //           text_decoration =
  //             paragraph_diff[idx + 1] && paragraph_diff[idx + 1].added
  //               ? "none" // green
  //               : "underline"; // orange

  //           // element = document.createElement("span");
  //           // element.style.color = diff_color;
  //           // // element.style.backgroundColor = bg_color;
  //           // // element.style.padding = ".2rem";
  //           // // element.style.borderRadius = "4px";
  //           // // element.style.marginRight = ".08rem";
  //           // // element.style.marginLeft = ".08rem";
  //           // element.appendChild(document.createTextNode(part.value));
  //           // console.log(part.value);
  //           // error_count += 1;
  //           if (addedWord && addedWord.includes(part.value.trim())) {
  //             // element = document.createElement("span");
  //             // element.style.color = "#3EB160";
  //             // element.appendChild(document.createTextNode(part.value));
  //           } else {
  //             removedWord = part.value;
  //             if (paragraph_diff[idx + 1] && paragraph_diff[idx + 1].added) {
  //               // element = document.createElement("span");
  //               // element.style.color = diff_color;
  //               // element.style.textDecoration = text_decoration;
  //               // element.appendChild(document.createTextNode(part.value));
  //             } else {
  //               element = document.createElement("span");
  //               element.style.color = diff_color;
  //               element.style.textDecoration = text_decoration;
  //               element.appendChild(document.createTextNode(part.value));
  //             }
  //             errors.push(part.value);
  //             error_count += 1;
  //           }
  //         } else if (part.added) {
  //           addedWord = part.value;
  //           // diff_color = part.added ? "#fff" : "#627081";
  //           // bg_color = part.added ? "#E03D3C" : "#ffff80";
  //           let value = part.value;
  //           bg_color = "#E03D3C";
  //           diff_color = "#E03D3C";

  //           element = document.createElement("span");
  //           element.style.color = diff_color;
  //           element.style.textDecoration = "underline";
  //           if (!part.value.trim()) {
  //             // element.style.backgroundColor = bg_color;
  //             // element.style.padding = ".2rem";
  //             // element.style.borderRadius = "4px";
  //             // element.style.marginRight = ".08rem";
  //             // element.style.marginLeft = ".08rem";
  //             value = "_";
  //             errors.push(value);
  //             error_count += 1;
  //           }
  //           element.appendChild(document.createTextNode(value));
  //           if (
  //             !paragraph_diff[idx - 1].removed &&
  //             !removedWord.includes(value.trim())
  //           ) {
  //             errors.push(value);
  //             error_count += 1;
  //           }
  //         } else {
  //           commonTexts += part.value;
  //           element = document.createTextNode(part.value);
  //         }
  //         paragraph.appendChild(element);
  //       });
  //     } else {
  //       // Split the reference text and user input into arrays of words
  //       const referenceWords = reference_text_paragraph.split(" ");
  //       const userInputWords = typing_answer_paragraphs[index].split(" ");

  //       // Initialize an array to store corrected words
  //       const correctedWords = [];

  //       // Loop through each word in the user input
  //       userInputWords.forEach((word, index) => {
  //         // If the word matches the corresponding word in the reference text, use the reference word
  //         if (referenceWords[index] && word !== referenceWords[index]) {
  //           correctedWords.push(referenceWords[index]);
  //         } else {
  //           correctedWords.push(word);
  //         }
  //       });

  //       // Join the corrected words into a single string
  //       const corrected = correctedWords.join(" ");
  //       console.log(correctedWords);
  //       console.log(userInputWords);

  //       const diffs = diffWordsWithSpace(
  //         corrected,
  //         typing_answer_paragraphs[index],
  //         { ignoreWhitespace: false }
  //       );
  //       // diffs.pop();
  //       console.log(diffs);
  //       diffs.forEach((part, idx) => {
  //         if (part.removed) {
  //           // diff_color = part.added ? "#fff" : "#627081";
  //           // bg_color = part.added ? "#E03D3C" : "#ffff80";
  //           diff_color =
  //             paragraph_diff[idx + 1] && paragraph_diff[idx + 1].added
  //               ? "#3EB160"
  //               : "#FA9A47";
  //           text_decoration =
  //             paragraph_diff[idx + 1] && paragraph_diff[idx + 1].added
  //               ? "none" // green
  //               : "underline"; // orange
  //           // element = document.createElement("span");
  //           // element.style.color = diff_color;
  //           // // element.style.backgroundColor = bg_color;
  //           // // element.style.padding = ".2rem";
  //           // // element.style.borderRadius = "4px";
  //           // // element.style.marginRight = ".08rem";
  //           // // element.style.marginLeft = ".08rem";
  //           // element.appendChild(document.createTextNode(part.value));
  //           // console.log(part.value);
  //           // error_count += 1;

  //           if (addedWord && addedWord.includes(part.value.trim())) {
  //             // element = document.createElement("span");
  //             // element.style.color = "#3EB160";
  //             // element.appendChild(document.createTextNode(part.value));
  //           } else {
  //             removedWord = part.value;
  //             if (paragraph_diff[idx + 1] && paragraph_diff[idx + 1].added) {
  //               // element = document.createElement("span");
  //               // element.style.color = diff_color;
  //               // element.style.textDecoration = text_decoration;
  //               // element.appendChild(document.createTextNode(part.value));
  //             } else {
  //               element = document.createElement("span");
  //               element.style.color = diff_color;
  //               element.style.textDecoration = text_decoration;
  //               element.appendChild(document.createTextNode(part.value));
  //             }
  //             errors.push(part.value);
  //             error_count += 1;
  //           }

  //           // if (paragraph_diff[idx - 2] && "added" in paragraph_diff[idx - 2]) {
  //           //   let text1 = part.value.trim();
  //           //   let text2 = paragraph_diff[idx - 2].value;
  //           //   // console.log(text1);
  //           //   // console.log(text2);
  //           //   // console.log(text2.includes(text1));
  //           //   if (!text2.includes(text1)) {
  //           //     removedWord = part.value;
  //           //     element = document.createElement("span");
  //           //     element.style.color = diff_color;
  //           //     element.appendChild(document.createTextNode(part.value));
  //           //     errors.push(part.value);
  //           //     error_count += 1;
  //           //   } else {
  //           //     element = document.createElement("span");
  //           //     element.style.color = "#3EB160"; // orange
  //           //     element.appendChild(document.createTextNode(part.value));
  //           //     errors.push(part.value);
  //           //     error_count += 1;
  //           //   }
  //           // } else {
  //           //   element = document.createElement("span");
  //           //   element.style.color = diff_color;
  //           //   element.appendChild(document.createTextNode(part.value));
  //           //   errors.push(part.value);
  //           //   error_count += 1;
  //           // }
  //         } else if (part.added) {
  //           addedWord = part.value;
  //           // diff_color = part.added ? "#fff" : "#627081";
  //           // bg_color = part.added ? "#E03D3C" : "#ffff80";
  //           let value = part.value;
  //           diff_color = "#E03D3C";
  //           bg_color = "#E03D3C";
  //           element = document.createElement("span");
  //           element.style.color = diff_color;
  //           element.style.textDecoration = "underline";
  //           if (!part.value.trim()) {
  //             // element.style.backgroundColor = bg_color;
  //             // element.style.padding = ".2rem";
  //             // element.style.borderRadius = "4px";
  //             // element.style.marginRight = ".08rem";
  //             // element.style.marginLeft = ".08rem";
  //             value = "_";
  //             errors.push(value);
  //             error_count += 1;
  //           }
  //           element.appendChild(document.createTextNode(value));
  //           if (
  //             !paragraph_diff[idx - 1].removed &&
  //             !removedWord.includes(value.trim())
  //           ) {
  //             errors.push(value);
  //             error_count += 1;
  //           }
  //         } else {
  //           commonTexts += part.value;
  //           element = document.createTextNode(part.value);
  //         }
  //         paragraph.appendChild(element);
  //       });
  //     }
  //   }
  //   fragment.appendChild(paragraph);
  // });

  // Split the reference text and user input into arrays of words
  const referenceWords = reference_typing_text.split(" ");
  const userInputWords = typing_answer.split(" ");

  // Initialize an array to store corrected words
  const correctedWords = [];

  // Loop through each word in the user input
  userInputWords.forEach((word, index) => {
    // If the word matches the corresponding word in the reference text, use the reference word
    if (referenceWords[index] && word !== referenceWords[index]) {
      correctedWords.push(referenceWords[index]);
    } else {
      correctedWords.push(word);
    }
  });

  // Join the corrected words into a single string
  const corrected = correctedWords.join(" ");

  // typing_test_diff.pop();
  let lastRemovedTrueIndex = -1;
  let lastAddedTrueIndex = -1;
  typing_test_diff.forEach((item, index) => {
    if (item.removed === true) {
      lastRemovedTrueIndex = index;
    }
    if (item.added === true) {
      lastAddedTrueIndex = index;
    }
  });

  paragraph = document.createElement("p");
  paragraph.style.lineHeight = "normal";

  typing_test_diff.forEach((part, index) => {
    if (part.added) {
      addedWord = part.value;
      element = document.createElement("span");
      element.style.fontSize = "15px";
      element.style.color = "#E03D3C";
      element.appendChild(
        document
          .createElement("strong")
          .appendChild(
            document.createTextNode(
              !part.value.trim()
                ? " " + "_".repeat(part.value.length - 1)
                : part.value
            )
          )
      );

      if (typing_test_diff[index - 1] && typing_test_diff[index - 1].removed) {
        error_count++;
        errors.push(part.value);
      } else {
        if (!removedWord.includes(part.value.trim())) {
          error_count++;
          errors.push(part.value);
        }
      }

      if (part.value === "\n\n" || part.value.includes("\n\n")) {
        element.appendChild(document.createElement("br"));
        element.appendChild(document.createElement("br"));
      }
      // ---
      // addedWord = part.value;
      // const isLastAddedTrue = index === lastAddedTrueIndex;
      // if (!isLastAddedTrue) {
      //   element = document.createElement("span");
      //   element.style.color = "#E03D3C";
      //   element.style.fontSize = "15px";
      //   element.appendChild(
      //     document.createTextNode(
      //       !part.value.trim() ? "_".repeat(part.value.length) : part.value
      //     )
      //   );
      //   if (
      //     !typing_test_diff[index - 1].removed &&
      //     !removedWord.includes(part.value.trim())
      //   ) {
      //     errors.push(part.value);
      //     error_count++;
      //   }
      // } else {
      //   element = document.createElement("span");
      //   element.style.color = "#627081";
      //   element.style.fontSize = "15px";

      //   element.appendChild(document.createTextNode(part.value));
      // }
      // if (part.value === "\n\n" || part.value.includes("\n\n")) {
      //   console.log("here");
      //   element.appendChild(document.createElement("br"));
      //   element.appendChild(document.createElement("br"));
      // }
    } else if (part.removed) {
      if (
        typing_test_diff[index + 1] !== undefined &&
        !typing_test_diff[index + 1].added &&
        corrected.includes(part.value) &&
        addedWord &&
        !addedWord.includes(part.value.trim())
      ) {
        // create an element in ORANGE color if the next part is not added=true and value is in corrected texts
        element = document.createElement("span");
        element.style.fontSize = "15px";
        element.style.color = "#FA9A47";
        element.appendChild(
          document
            .createElement("strong")
            .appendChild(document.createTextNode(part.value))
        );
        error_count++;
        errors.push(part.value);

        if (part.value === "\n\n" || part.value.includes("\n\n")) {
          element.appendChild(document.createElement("br"));
          element.appendChild(document.createElement("br"));
        }
      } else {
        removedWord = part.value;
      }
      // ---
      // const isLastRemovedTrue = index === lastRemovedTrueIndex;
      // console.log(isLastRemovedTrue);
      // if (!isLastRemovedTrue) {
      //   if (addedWord && !addedWord.includes(part.value.trim())) {
      //     removedWord = part.value;
      //     if (
      //       typing_test_diff[index + 1] &&
      //       !typing_test_diff[index + 1].added
      //     ) {
      //       element = document.createElement("span");
      //       element.style.color = "#FA9A47";
      //       element.style.fontSize = "15px";
      //       element.appendChild(
      //         document.createTextNode(
      //           !part.value.trim() ? "_".repeat(part.value.length) : part.value
      //         )
      //       );
      //       error_count++;
      //       if (part.value === "\n\n" || part.value.includes("\n\n")) {
      //         console.log("here");
      //         element.appendChild(document.createElement("br"));
      //         element.appendChild(document.createElement("br"));
      //       }
      //     }
      //     errors.push(part.value);
      //   }
      // }
    } else {
      element = document.createElement("span");
      element.style.fontSize = "15px";
      element.style.color = "#627081";
      element.appendChild(document.createTextNode(part.value));

      if (part.value === "\n\n" || part.value.includes("\n\n")) {
        element.appendChild(document.createElement("br"));
        element.appendChild(document.createElement("br"));
      }
    }
    fragment.appendChild(element);
  });

  const tempContainer = document.createElement("div");
  tempContainer.style.lineHeight = "1.7rem";
  tempContainer.appendChild(fragment);
  return { tempContainer, error_count, commonTexts };
};
